import axios, { AxiosResponse } from "axios";
import { IDuas } from "../Types/IDuas";

const api = axios.create({
  baseURL: "https://api.farooqiah.co.uk/",
  timeout: 10000,
  headers: { token: "b486d351-7cef-4da8-90c6-09fc3dca546f" },
});

export const dailyDuas = (): Promise<IDuas[] | void> => {
  return api
    .get("Duas", {
      params: {
        token: "b486d351-7cef-4da8-90c6-09fc3dca546f",
      },
    })
    .then((response: AxiosResponse<IDuas[]>) => {
      const data: IDuas[] = [];

      console.log("daily duas api called @ " + new Date());
      console.log(response.data);

      response.data.forEach((dua: IDuas) => {
        const d: IDuas = {
          Id: dua.Id,
          Day: dua.Day,
          header: dua.header,
          body: dua.body,
          footer: dua.footer,
        };

        data.push(d);
      });

      //const test = JSON.stringify(response.data);
      return data;
    })
    .catch(function (error: any) {
      console.log("api error @ " + new Date());
      console.log(error);
      return;
    });
};
